module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-cn/banner0-3206242538fd770fda80dcdf83f91229.jpg";